/* ama-highlight-last.js
   Colora di terracotta (#c07050) l'ultima parola dei TITOLI di
   sezione VERDI. Prende gli heading nel contenuto (main), esclude
   header/menu/drawer/footer/card/bottoni/link, e agisce solo se
   l'ultima parola e' effettivamente verde (rgb ~63,125,95): cosi'
   salta gli hero su sfondo scuro (crema) e le parole gia' terracotta.
   Gestisce split-words ed <em>. */
(function () {
  'use strict';
  function isGreen(c) {
    var m = (c.match(/\d+/g) || []).map(Number);
    if (m.length < 3) return false;
    return Math.abs(m[0] - 63) <= 45 && Math.abs(m[1] - 125) <= 48 && Math.abs(m[2] - 95) <= 45;
  }
  function eligible(h) {
    if (!h.closest('#MainContent, main')) return false;
    if (h.closest('header, footer, nav, .header, .footer, [class*="drawer"], [class*="menu"], [class*="mega"], .product-card, .card, .breadcrumb, .cart, [class*="announcement"], a, button')) return false;
    return true;
  }
  function lastTextNode(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.replace(/\s+/g, '')) last = n; }
    return last;
  }
  function process(h) {
    if (h.querySelector('.ama-lw')) return; // gia' fatto
    var tn = lastTextNode(h);
    if (!tn || !tn.parentElement) return;
    if (!isGreen(getComputedStyle(tn.parentElement).color)) return; // solo se verde
    var txt = tn.nodeValue;
    var trail = (txt.match(/\s*$/) || [''])[0];
    var core = txt.slice(0, txt.length - trail.length);
    var i = core.search(/\S+$/);
    if (i < 0) return;
    var before = core.slice(0, i), word = core.slice(i);
    var span = document.createElement('span');
    span.className = 'ama-lw';
    span.textContent = word + trail;
    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));
    frag.appendChild(span);
    tn.parentNode.replaceChild(frag, tn);
  }
  function init() {
    var heads = document.querySelectorAll('.heading');
    for (var i = 0; i < heads.length; i++) {
      if (eligible(heads[i])) process(heads[i]);
    }
  }
  function boot() {
    init();
    setTimeout(init, 400);
    setTimeout(init, 1200);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', boot);
})();

/* ------------------------------------------------------------
   ama-promo-bar (accodato)
   Barra verticale fissa a sinistra: cambia "Scopri le novita'"
   in "Le promozioni" e la fa puntare alla COLLEZIONE
   "Promozioni del mese" (/collections/promozioni-del-mese)
   invece di aprire il popup newsletter.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  var PROMO_URL = '/collections/promozioni-del-mese';
  function fix() {
    var btn = document.querySelector('.newsletter-bar__button');
    if (!btn) return false;
    if (btn.getAttribute('data-ama-promo') === '1') return true;
    btn.setAttribute('data-ama-promo', '1');
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Le promozioni';
    else btn.textContent = 'Le promozioni';
    btn.setAttribute('href', PROMO_URL);
    btn.removeAttribute('role');
    btn.removeAttribute('aria-controls');
    btn.removeAttribute('aria-expanded');
    btn.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      window.location.href = PROMO_URL;
    }, true);
    var bar = btn.closest('.newsletter-bar');
    if (bar) bar.style.color = '#3F7D5F';
    return true;
  }
  function boot() {
    if (!fix()) { setTimeout(fix, 400); setTimeout(fix, 1200); }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ------------------------------------------------------------
   ama-oe-carousel (accodato)
   Su MOBILE (<1024px) trasforma le card verdi (oe-info) in un
   carosello vero: scroll orizzontale con snap, card che sbircia
   la successiva, e puntini cliccabili sotto.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  var CSS = [
    '@media (max-width:1023px){',
    '  .oe-info__track{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;scroll-snap-type:x mandatory!important;gap:14px!important;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:2px;}',
    '  .oe-info__track::-webkit-scrollbar{display:none;}',
    '  .oe-info__track>.oe-info__card{flex:0 0 84%!important;width:84%!important;max-width:84%!important;scroll-snap-align:center!important;}',
    '  .ama-oe-dots{display:flex!important;}',
    '}',
    '.ama-oe-dots{display:none;justify-content:center;align-items:center;gap:8px;margin-top:18px;}',
    '.ama-oe-dots .ama-oe-dot{width:8px;height:8px;border-radius:50%;border:0;padding:0;background:rgba(63,125,95,0.28);cursor:pointer;transition:background .25s ease,transform .25s ease;}',
    '.ama-oe-dots .ama-oe-dot.is-active{background:#3F7D5F;transform:scale(1.25);}'
  ].join('\n');
  function injectStyle() {
    if (document.getElementById('ama-oe-style')) return;
    var s = document.createElement('style');
    s.id = 'ama-oe-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function build(sec) {
    var track = sec.querySelector('.oe-info__track');
    if (!track) return;
    var cards = [].slice.call(track.querySelectorAll(':scope > .oe-info__card'));
    if (cards.length < 2) return;
    if (sec.querySelector('.ama-oe-dots')) return;
    var dots = document.createElement('div');
    dots.className = 'ama-oe-dots';
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ama-oe-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Vai alla card ' + (i + 1));
      b.addEventListener('click', function () {
        var delta = c.getBoundingClientRect().left - track.getBoundingClientRect().left;
        var target = track.scrollLeft + delta - (track.clientWidth - c.clientWidth) / 2;
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    var ds = dots.querySelectorAll('.ama-oe-dot');
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var tr = track.getBoundingClientRect();
        var center = tr.left + tr.width / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        for (var i = 0; i < ds.length; i++) { ds[i].classList.toggle('is-active', i === best); }
      });
    }, { passive: true });
  }
  function boot() {
    injectStyle();
    var secs = document.querySelectorAll('.oe-info');
    for (var i = 0; i < secs.length; i++) build(secs[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ------------------------------------------------------------
   ama-btn-fix (accodato)
   La sezione "Esplora le collezioni" ha color_button_background
   verdone in index.json (rimesso dall'editor/pubblicazione). Qui
   forziamo i suoi pulsanti (tab attiva, "Vedi tutti", frecce) in
   salvia via variabile di schema. Vince sempre.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  if (document.getElementById('ama-btn-fix')) return;
  var css = '#shopify-section-template--30353478910295__collezioni{--color-button-background:63 125 95 !important;--color-button-border:63 125 95 !important;}';
  var s = document.createElement('style');
  s.id = 'ama-btn-fix';
  s.textContent = css;
  (document.head || document.documentElement).appendChild(s);
})();

/* ------------------------------------------------------------
   ama-text-reveal (accodato)
   Animazione dei TESTI: titoli di sezione, blocchi di testo
   (rich-text), intro delle card verdi e colonne "Cosa trovi da
   noi" compaiono con un morbido fade + slide-up quando entrano
   nello schermo (IntersectionObserver). Rispetta prefers-reduced-
   motion. Se JS/IO non ci sono, i testi restano visibili.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  function injectStyle() {
    if (document.getElementById('ama-anim-style')) return;
    var s = document.createElement('style');
    s.id = 'ama-anim-style';
    s.textContent = '.ama-anim{opacity:0;transform:translateY(18px);transition:opacity .7s cubic-bezier(.22,.61,.36,1),transform .7s cubic-bezier(.22,.61,.36,1);will-change:opacity,transform;}.ama-anim.ama-in{opacity:1;transform:none;}';
    document.head.appendChild(s);
  }
  var io = null;
  function ensureIO() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ama-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    return io;
  }
  function mark(el, delay) {
    if (!el || el.classList.contains('ama-anim')) return;
    el.classList.add('ama-anim');
    if (delay) el.style.transitionDelay = delay + 's';
    var o = ensureIO();
    if (o) o.observe(el); else el.classList.add('ama-in');
  }
  function run() {
    injectStyle();
    var main = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
    [].forEach.call(main.querySelectorAll('.heading'), function (h) {
      if (h.closest('.rich-text') || h.closest('.oe-info__intro') || h.closest('.banner') || h.closest('.slideshow')) return;
      mark(h, 0);
    });
    [].forEach.call(main.querySelectorAll('.rich-text, .oe-info__intro'), function (el) { mark(el, 0); });
    [].forEach.call(main.querySelectorAll('.text-with-icons > .column'), function (c, i) { mark(c, Math.min(i, 6) * 0.1); });
  }
  function boot() { run(); setTimeout(run, 700); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ------------------------------------------------------------
   ama-breadcrumb (accodato)
   Nel breadcrumb la voce "Collezioni" (link a /collections) non
   deve essere cliccabile: la trasformiamo in semplice testo,
   mantenendo l'aspetto. L'icona Home resta cliccabile.
   ------------------------------------------------------------ */
(function () {
  'use strict';
  function isCollectionsIndex(href) {
    if (!href) return false;
    var h = href.split('?')[0].replace(/\/$/, '');
    return h === '/collections';
  }
  function fix() {
    var bcs = document.querySelectorAll('.breadcrumb');
    for (var i = 0; i < bcs.length; i++) {
      var links = bcs[i].querySelectorAll('a');
      for (var j = 0; j < links.length; j++) {
        var a = links[j];
        if (!isCollectionsIndex(a.getAttribute('href'))) continue;
        var span = document.createElement('span');
        span.className = a.className;
        span.innerHTML = a.innerHTML;
        span.style.cursor = 'default';
        span.style.pointerEvents = 'none';
        a.parentNode.replaceChild(span, a);
      }
    }
  }
  function boot() { fix(); setTimeout(fix, 500); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
